export function generateFaqSchema(faqData = []) {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map((item) => {
        // Merge answers and list as HTML
        const listItems = item.list
          ?.map((li) => `<li>${li}</li>`)
          .join("") || "";
        const combinedAnswer = `${item.answers ? item.answers:''} ${listItems ?`<ul>${listItems}</ul>`:''}`;
  
        return {
          "@type": "Question",
          "name": item.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": combinedAnswer
          }
        };
      })
    };
  }
  